import React, { useState, useEffect, useRef } from 'react'
import {
    Box, TextField, Tooltip
} from "@mui/material";
import PricingCopyMenu from './PricingCopyMenu'
import { deepCopy } from '../../../app/util';

const DifferentialInput = ({ day, room, season, seasonEditCopyRef, isReadOnlyMode, manageSeasonChangeFunc, discardCount, offsetType, disableDownCopy, disableRightCopy, copyInputCount, inventoryRoomCodes }) => {
    const { room_type } = seasonEditCopyRef.current.dependent_room_type;

    const inputRef = useRef(null);
    const [inputErrorMsg, setInputErrorMsg] = useState(false);

    const handleInputFocus = (event) => {
        // Remove all formatted symbols before edit
        const isNegetive = event?.target?.value?.indexOf('(');
        const value = event.target.value.replace(/[()%]/g, '').replace('%', '').trim();
        event.target.value = isNegetive > -1 ? Number(-value) : value;

        // Select all text on focus
        // setTimeout(() => {
        event.target.select();
        // }, 0);
    };

    const handleInputBlur = (event) => {
        let input = event.target.value.trim();
        input = input.replace(/[()%]/g, '').replace('%', '');

        // if input is blank
        if (input === '') {
            setInputErrorMsg('This field is required.');
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day] = null;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // If input is not a number then replace with 0
        let numericValue = Number(input);
        if (isNaN(numericValue)) {
            numericValue = 0;
        }

        // Adjust decimal values based on offsetType
        if (offsetType === "percentage") {
            numericValue = Math.trunc(numericValue * 10) / 10; // keep only one decimal
        } else {
            numericValue = Math.trunc(numericValue); // remove decimals
        }

        // Save the clean numeric value for payload
        if(seasonEditCopyRef.current.dependent_room_type.room_type[room]){
            seasonEditCopyRef.current.dependent_room_type.room_type[room][day] = numericValue;
        }
        
        manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });

        event.target.value = formatForDisplay(numericValue); // Formatted value to display in UI

        setInputErrorMsg(false);

        //console.log("seasonEditCopyRef.current", seasonEditCopyRef.current.dependent_room_type)
    };

    const formatForDisplay = (num) => {
        if (num === null || num === undefined || num === '') return '';
        const isNegative = Number(num) < 0;
        const numVal = Math.abs(Number(num));
        let formattedVal = numVal;

        if (offsetType === "percentage") {
            formattedVal += '%';
        }
        if (isNegative) {
            formattedVal = `(${formattedVal})`;
        }
        return formattedVal;
    };

    useEffect(() => {
        setInputErrorMsg(false);
        // if(room==='demoroom14'){ debugger;}
        if (season?.dependent_room_type?.room_type[room]) {
            const val = season?.dependent_room_type?.room_type[room][day];
            inputRef.current.value = formatForDisplay(val);
        } else {
            season.dependent_room_type.room_type[room] = {};
            season.dependent_room_type.room_type[room][day] = null;
            const val = season?.dependent_room_type?.room_type[room][day];
            inputRef.current.value = formatForDisplay(val);
        }

    }, [discardCount, offsetType]);

    const handleCopyRight = () => {
        const currentValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day];
        const dayKeys = Object.keys(seasonEditCopyRef.current.dependent_room_type.room_type[room]);
        const currentIndex = dayKeys.indexOf(day);
        if (currentIndex === -1) return;

        // Copy value to the right-side inputs
        for (let i = currentIndex + 1; i < dayKeys.length; i++) {
            const nextDay = dayKeys[i];
            seasonEditCopyRef.current.dependent_room_type.room_type[room][nextDay] = currentValue;
        }

        manageSeasonChangeFunc({
            action: 'copyInput',
            season: seasonEditCopyRef.current,
        });

        console.log("seasonEditCopyRef.current", seasonEditCopyRef.current)
    };

    const handleCopyDown = () => {
        const currentValue = seasonEditCopyRef.current.dependent_room_type.room_type[room][day];
        const allRooms = deepCopy(inventoryRoomCodes); // Object.keys(seasonEditCopyRef.current.dependent_room_type.room_type);
        const currentRoomIndex = allRooms.indexOf(room);
        if (currentRoomIndex === -1) return;

        // Copy value to the below inputs of same day 
        for (let i = currentRoomIndex + 1; i < allRooms.length; i++) {
            const nextRoom = allRooms[i];
            if(!seasonEditCopyRef.current.dependent_room_type.room_type[nextRoom]) debugger;
            seasonEditCopyRef.current.dependent_room_type.room_type[nextRoom][day] = currentValue;
        }

        manageSeasonChangeFunc({
            action: 'copyInput',
            season: seasonEditCopyRef.current,
        });

        console.log("seasonEditCopyRef.current", seasonEditCopyRef.current)
    };

    useEffect(() => {
        if (seasonEditCopyRef?.current?.dependent_room_type?.room_type[room]) {
            inputRef.current.value = formatForDisplay(seasonEditCopyRef.current.dependent_room_type.room_type[room][day])

            // clear the error on copied inputs
            if (seasonEditCopyRef.current.dependent_room_type.room_type[room][day] !== null) {
                setInputErrorMsg(false);
            }
        }

    }, [copyInputCount]);

    const handleArrowKeyNavigation = (event) => {
        const key = event.key;

        if (key !== "ArrowUp" && key !== "ArrowDown" && key !== "ArrowLeft" && key !== "ArrowRight") {
            return;
        }

        event.preventDefault();

        const allRooms = Object.keys(
            seasonEditCopyRef.current.dependent_room_type.room_type
        );
        const allDays = Object.keys(
            seasonEditCopyRef.current.dependent_room_type.room_type[room]
        );

        const currentRoomIndex = allRooms.indexOf(room);
        const currentDayIndex = allDays.indexOf(day);

        let targetRoom = room;
        let targetDay = day;

        if (key === "ArrowUp" && currentRoomIndex > 0) {
            targetRoom = allRooms[currentRoomIndex - 1];
        }
        if (key === "ArrowDown" && currentRoomIndex < allRooms.length - 1) {
            targetRoom = allRooms[currentRoomIndex + 1];
        }
        if (key === "ArrowLeft" && currentDayIndex > 0) {
            targetDay = allDays[currentDayIndex - 1];
        }
        if (key === "ArrowRight" && currentDayIndex < allDays.length - 1) {
            targetDay = allDays[currentDayIndex + 1];
        }

        // Final target input
        const targetInput = document.getElementById(`dif-input-${targetRoom}-${targetDay}`);

        if (targetInput) {
            targetInput.focus();
            targetInput.select();
        }
    };

    return (
        <Box className="grid-col" key={day}>
            <Tooltip
                arrow
                title={inputErrorMsg}
                placement="top"
                slotProps={{
                    tooltip: {
                        sx: {
                            maxWidth: 350,
                        },
                    },
                }}
            >
                <TextField
                    type="text"
                    inputRef={inputRef}
                    className={`
                        custon-textfield 
                        ${room_type[room] && room_type[room][day] === null && !season.id.includes('new_') ? 'empty_field' : ''} 
                        ${inputErrorMsg ? 'error' : ''}
                    `}
                    size="small"
                    fullWidth
                    margin="dense"
                    disabled={isReadOnlyMode}
                    defaultValue={room_type[room] ? formatForDisplay(room_type[room][day]) : null}
                    onFocus={(event) => { handleInputFocus(event) }}
                    onBlur={(event) => { handleInputBlur(event) }}
                    onKeyDown={handleArrowKeyNavigation}
                    inputProps={{
                        id: `dif-input-${room}-${day}`,
                    }}
                    autoComplete="off"
                />
                {!isReadOnlyMode && room_type[room] && room_type[room][day] !== null && room_type[room][day] !== undefined && (
                    <PricingCopyMenu
                        disableDownCopy={disableDownCopy}
                        disableRightCopy={disableRightCopy}
                        onCopyRight={handleCopyRight}
                        onCopyDown={handleCopyDown}
                    />
                )}
            </Tooltip>
        </Box>
    )
}

export default DifferentialInput